import type { FC, ReactNode } from "react";
import { useEffect } from "react";

import { LoadingContext } from "@shared/context";
import { useBooleanAggregator } from "@shared/hooks";

import { Events } from "./events";

interface Props {
  children: ReactNode;
}

const LoadingProvider: FC<Props> = ({ children }) => {
  const [mutationLoading, incrementMutationLoading, decrementMutationLoading] =
    useBooleanAggregator();
  const [queryLoading, incrementQueryLoading, decrementQueryLoading] = useBooleanAggregator();

  useEffect(() => {
    document.addEventListener(Events.INCREMENT_MUTATION, incrementMutationLoading);
    document.addEventListener(Events.DECREMENT_MUTATION, decrementMutationLoading);
    return () => {
      document.removeEventListener(Events.INCREMENT_MUTATION, incrementMutationLoading);
      document.removeEventListener(Events.DECREMENT_MUTATION, decrementMutationLoading);
    };
  }, [incrementMutationLoading, decrementMutationLoading]);

  return (
    <LoadingContext.Provider
      value={{
        mutationLoading,
        incrementMutationLoading,
        decrementMutationLoading,
        queryLoading,
        incrementQueryLoading,
        decrementQueryLoading,
      }}
    >
      {children}
    </LoadingContext.Provider>
  );
};

export { LoadingProvider };
